// SimpleTag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Flex, Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************

export const SimpleTag = ({
  tags = [],
  className,
  gap = '4px 0',
  align = 'left',
  variant = 'filled',
  tagStyle,
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const justify = align === 'right' ? 'flex-end' : 'flex-start';

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Flex gap={gap} wrap justify={justify}>
      {tags?.map((tag, idx) => (
        <Tag
          key={tag?.key || idx}
          color={tag?.color}
          variant={tag?.variant || variant}
          onClick={tag?.onClick}
          style={{ marginInlineEnd: 8, ...tagStyle }} // espaçamento à direita
        >
          <span className={className} style={tag?.textColor ? { color: tag.textColor } : undefined}>
            {translateX(tag?.label)}
          </span>
        </Tag>
      ))}
    </Flex>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleTag;
